import React, {useContext, useEffect, useState} from 'react';

import {AppContext} from '../../../AppModule/Context';

import ChatPlaceholderComponent from './chatPlaceholderComponent';
import MultiExpertWidgetAccountRow from './multiExpertWidgetAccountRow';
import PoweredByConsoltoComponent from '../openWidgetComponent/poweredByConsoltoComponent';
import WidgetHeaderComponent from '../openWidgetComponent/widgetHeaderComponent';

import VIDABOO_CONSTANTS from '../../../config/consts';

import utilsService from '../../../services/utilsService';
// import multiWidgetService from '../../../services/multiWidgetService';

const MultiExpertAgentsListWithHeaderComponent = ({
  isDemo = false,
  filteredSortedMentorsCtrlDtoValues = [],
  widgetDto = {},
  closeMultiWidget = () => {},
  handleTransitionToTeamChatRoom = () => {},
  openCloseSpecificWidgetV2 = () => {},
  openWidgetByTabType = () => {},
}) => {
  const context = useContext(AppContext);

  const [manipulatedPhotoUrl, setManipulatedPhotoUrl] = useState(null);
  // const [teamMentorDto, setTeamMentorDto] = useState(null);

  useEffect(() => {
    const manipulatedPhotoUrl = getPhotoManipulatedUrl();
    // const teamMentorDto =
    //   multiWidgetService.getFirstWidgetTeamMentorCtrlDto(widgetDto);
    setManipulatedPhotoUrl(manipulatedPhotoUrl);
    // setTeamMentorDto(teamMentorDto);
  }, [widgetDto, filteredSortedMentorsCtrlDtoValues]);

  const getPhotoManipulatedUrl = () => {
    const widgetProfilePhotoDto =
      utilsService.getPhotoDtoAndIdxByPhotoAndObjectType(
        widgetDto.widgetAppCtrlDto.photoDtos,
        VIDABOO_CONSTANTS.PHOTO_TYPES.PROFILE,
        VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.WIDGET,
      )?.photoDto;
    const manipulatedPhotoUrl = utilsService.getPhotoManipulatedUrl(
      widgetProfilePhotoDto,
      VIDABOO_CONSTANTS.CLOUDINARY_IMAGE_MANIPULATIONS.WIDGET_MASK_IMAGE,
    );
    return manipulatedPhotoUrl;
  };

  return (
    <div
      className={`et-accounts-magazine-section ${
        utilsService.getIsInWidget()
          ? 'et-accounts-magazine-section-height-full'
          : ''
      }`}>
      <WidgetHeaderComponent
        isDemo={isDemo}
        isInAgentList
        widgetDto={widgetDto}
        widgetProfileImage={manipulatedPhotoUrl}
        onHeaderCloseButton={closeMultiWidget}
      />
      <div
        className={`et-mw-single-widget-row-wrapper ${widgetDto.widgetAppCtrlDto.widgetInteractionMode === VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT ? 'et-mw-single-widget-row-wrapper-without-bottom-padding' : ''}`}>
        {filteredSortedMentorsCtrlDtoValues.map(
          (mentorControlMapDto, index) => {
            const exMentorDto = mentorControlMapDto.extendedMentorDto;
            return (
              <div
                key={exMentorDto.mentorDto.mentorId}
                className={`et-mw-single-widget-row
                    ${
                      index === filteredSortedMentorsCtrlDtoValues.length - 1 &&
                      widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
                        VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT
                        ? filteredSortedMentorsCtrlDtoValues.length >= 5
                          ? 'et-mw-single-widget-row-last-blur-margin'
                          : 'et-mw-single-widget-row-last-normal-margin'
                        : ''
                    }`}>
                <MultiExpertWidgetAccountRow
                  isDemo={isDemo}
                  showMentorAvailabilityStatus={
                    widgetDto.widgetAppCtrlDto.availabilityBeacon !== false
                  }
                  extendedMentorDto={exMentorDto}
                  peerAvailability={
                    context.peersStatus[exMentorDto.mentorDto.mentorOwnerId]
                  }
                  profileImage={utilsService.getPhotoManipulatedUrl(
                    exMentorDto.photoDto,
                    VIDABOO_CONSTANTS.CLOUDINARY_IMAGE_MANIPULATIONS
                      .WIDGET_MASK_IMAGE,
                  )}
                  openWidget={() => {
                    openCloseSpecificWidgetV2(exMentorDto.mentorDto.mentorId);
                  }}
                  onFooterOptionSelected={(selectedWidgetAppType) => {
                    openWidgetByTabType({
                      mentorId: exMentorDto.mentorDto.mentorId,
                      selectedWidgetAppType,
                      etClickInitiator:
                        VIDABOO_CONSTANTS.ACTION_CLICK_INITIATOR.FOOTER,
                    });
                  }}
                />
              </div>
            );
          },
        )}
      </div>
      <ChatPlaceholderComponent
        widgetDto={widgetDto}
        onSend={() => {
          handleTransitionToTeamChatRoom();
        }}
        showBottomBlur={filteredSortedMentorsCtrlDtoValues.length >= 5}
      />
      {!widgetDto?.widgetAppCtrlDto?.whiteLabel && (
        <PoweredByConsoltoComponent
          isDemo={isDemo}
          category={VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET}
          eventAction={
            VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.CONSOLTO_MULTI_LINK
          }
          utmMedium={VIDABOO_CONSTANTS.UTM_MEDIUMS.WIDGET}
        />
      )}
    </div>
  );
};

export default MultiExpertAgentsListWithHeaderComponent;
